module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "field-survey-form-root"
  }, [_c('div', {
    staticClass: "field-survey-form-inner"
  }, [_c('header', {
    staticClass: "fsf-page-header"
  }, [_c('h1', {
    staticClass: "fsf-page-title"
  }, [(_vm.fieldSurveyLoading) ? [_vm._v(_vm._s(_vm.$t('FieldSurveyForm.loadingTitle')))] : (_vm.fieldSurveyError) ? [_vm._v(_vm._s(_vm.$t('FieldSurveyForm.titleError')))] : [_vm._v(_vm._s(_vm.pageTitle))]], 2)]), _vm._v(" "), _c('div', {
    staticClass: "fsf-main-card"
  }, [_c('section', {
    staticClass: "fsf-map-panel",
    attrs: {
      "aria-label": "field-survey-map"
    }
  }, [(!_vm.fieldSurveyLoading && !_vm.fieldSurveyError && _vm.fieldSurveyId) ? _c('field-survey-map', {
    ref: "fieldSurveyMap",
    staticClass: "fsf-map-embed",
    attrs: {
      "survey-works": _vm.surveyWorks,
      "devices-qty-number": _vm.devicesQtyNumber,
      "disabled": _vm.surveyWorksLoading || !_vm.isSetupEditable,
      "saving": _vm.mapSaving,
      "technician-items": _vm.technicianItems,
      "technician-options-loading": _vm.technicianOptionsLoading,
      "field-survey-id": _vm.fieldSurveyId
    },
    on: {
      "create-work": _vm.onCreateSurveyWorkFromMap,
      "add-blocked": _vm.onMapAddBlocked,
      "technician-user-created": _vm.onTechnicianUserCreated
    }
  }) : _c('div', {
    staticClass: "fsf-map-placeholder"
  }), _vm._v(" "), _c('div', {
    staticClass: "fsf-map-hint-banner",
    attrs: {
      "role": "status"
    }
  }, [_c('v-icon', {
    staticClass: "fsf-map-hint-icon",
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-information")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.mapHintText))])], 1)], 1), _vm._v(" "), _c('aside', {
    staticClass: "fsf-sidebar"
  }, [_c('div', {
    staticClass: "fsf-sidebar-header"
  }, [_c('span', {
    staticClass: "fsf-sidebar-count"
  }, [_vm._v(_vm._s(_vm.hiredEquipmentsText))]), _vm._v(" "), (_vm.showHireMoreLink) ? _c('a', {
    staticClass: "fsf-hire-more-link",
    attrs: {
      "href": _vm.hireMoreWhatsappUrl,
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('FieldSurveyForm.hireMore')) + "\n          ")]) : _vm._e()]), _vm._v(" "), (_vm.showEditServiceLink) ? _c('div', {
    staticClass: "fsf-edit-service-wrap"
  }, [_c('a', {
    staticClass: "fsf-edit-service-link",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.enableAdminEdit.apply(null, arguments)
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('FieldSurveyForm.editService')) + "\n          ")])]) : _vm._e(), _vm._v(" "), (_vm.surveyWorksLoading) ? _c('div', {
    staticClass: "fsf-sidebar-loading py-6 text-center"
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "#0091d5",
      "size": "32"
    }
  })], 1) : (_vm.surveyWorksError) ? _c('div', {
    staticClass: "fsf-sidebar-error caption grey--text px-2"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('FieldSurveyForm.surveyWorksError')) + "\n        ")]) : _c('div', {
    staticClass: "fsf-sidebar-list"
  }, [_vm._l((_vm.surveyWorks), function(work, index) {
    return _c('survey-work-card', {
      key: work.id,
      attrs: {
        "work": work,
        "marker-letter": _vm.markerLetter(index),
        "saving": _vm.savingId === work.id,
        "deleting": _vm.deletingId === work.id,
        "technician-items": _vm.technicianItems,
        "technician-options-loading": _vm.technicianOptionsLoading,
        "field-survey-id": _vm.fieldSurveyId,
        "readonly": !_vm.isSetupEditable
      },
      on: {
        "save": _vm.onSaveWork,
        "delete": _vm.onDeleteWork,
        "technician-user-created": _vm.onTechnicianUserCreated
      }
    })
  }), _vm._v(" "), (!_vm.surveyWorks.length) ? _c('p', {
    staticClass: "fsf-empty caption grey--text px-2"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('FieldSurveyForm.noSurveyWorks')) + "\n          ")]) : _vm._e()], 2), _vm._v(" "), (_vm.showConfirmButton) ? _c('div', {
    staticClass: "fsf-confirm-wrap"
  }, [_c('v-btn', {
    staticClass: "fsf-confirm-btn",
    attrs: {
      "block": "",
      "large": "",
      "depressed": "",
      "disabled": !_vm.canConfirm
    },
    on: {
      "click": _vm.onConfirmClick
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('FieldSurveyForm.confirm')) + "\n          ")])], 1) : (_vm.showFinishEditButton) ? _c('div', {
    staticClass: "fsf-confirm-wrap"
  }, [_c('v-btn', {
    staticClass: "fsf-confirm-btn",
    attrs: {
      "block": "",
      "large": "",
      "depressed": ""
    },
    on: {
      "click": _vm.finishAdminEdit
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('FieldSurveyForm.finishEditService')) + "\n          ")])], 1) : _vm._e()])])]), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "520",
      "content-class": "fsf-ponce-dialog-overlay"
    },
    on: {
      "click:outside": function($event) {
        _vm.ponceChargeConfirmDialog = false
      }
    },
    model: {
      value: (_vm.ponceChargeConfirmDialog),
      callback: function($$v) {
        _vm.ponceChargeConfirmDialog = $$v
      },
      expression: "ponceChargeConfirmDialog"
    }
  }, [_c('v-card', {
    staticClass: "fsf-ponce-dialog-card",
    attrs: {
      "flat": ""
    }
  }, [_c('v-btn', {
    staticClass: "fsf-ponce-close",
    attrs: {
      "icon": "",
      "aria-label": _vm.$t('FieldSurveyForm.cancel')
    },
    on: {
      "click": function($event) {
        _vm.ponceChargeConfirmDialog = false
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "grey darken-2"
    }
  }, [_vm._v("mdi-close")])], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "fsf-ponce-dialog-text pt-10 pb-2 text-center"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('FieldSurveyForm.ponceChargeWarningBody')) + "\n      ")]), _vm._v(" "), _c('v-card-actions', {
    staticClass: "fsf-ponce-dialog-actions px-4 pb-5 pt-2"
  }, [_c('v-btn', {
    staticClass: "fsf-ponce-btn-cancel",
    attrs: {
      "outlined": "",
      "depressed": ""
    },
    on: {
      "click": function($event) {
        _vm.ponceChargeConfirmDialog = false
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('FieldSurveyForm.cancel')) + "\n        ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "fsf-ponce-btn-ok",
    attrs: {
      "color": "#0091d5",
      "dark": "",
      "depressed": ""
    },
    on: {
      "click": _vm.onConfirmPonceCharges
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('FieldSurveyForm.confirm')) + "\n        ")])], 1)], 1)], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "timeout": _vm.snackbar.timeout,
      "color": _vm.snackbar.color,
      "top": ""
    },
    model: {
      value: (_vm.snackbar.show),
      callback: function($$v) {
        _vm.$set(_vm.snackbar, "show", $$v)
      },
      expression: "snackbar.show"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.snackbar.text) + "\n  ")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f9b851ae","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FieldSurveys/FieldSurveyForm.vue
// module id = 1755
// module chunks = 0